// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-container[data-v-2611e320] {\n  height: 100%;\n  padding-top: 3px;\n}\n.image[data-v-2611e320] {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--banner-avatar-border);\n  border-radius: 50%;\n  display: inline-block;\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  opacity: 1;\n  vertical-align: baseline;\n}\n", ""]);
// Exports
module.exports = exports;
